import Handler from "./handler";
import http from "../../../http";
import { getParamsFromQuery, sliceObject, getQuery } from "../xes-lib";
import { getGoldUrl, getCanBeShare, genQrCode, genShareUrl, extractVmJson } from "../xes";
// import {
//     closeWindowFunction,
//     setAnswerResult
// } from "../common";
import xesBridge from 'xes-code-base/lib/libs/xes'
import bindAll from "lodash.bindall";
import { onXESConfirmSubmit } from "../../../reducers/project-state"
import { sendClassWorkCheckLog,sendIntelligentPromptTrigger } from '../log'
class ClassHandler extends Handler {
  constructor() {
    super()
    this.liveParams = getParamsFromQuery("all");
    this.isAuto = false
    this.answerStartTime = 0 
    this.startTime = Date.now()// 记录初始时间
    // 讲座
    this.needNotCorrect = getQuery('parent') === 'biglive'
    
    // 战队PK
    this.goldNum = getQuery('goldNum')      // 学生获得的金币数
    this.testId = getQuery('testId')        // 金币总数
    this.inputGoldNum = getQuery('goldNum') // testId
    this.bigClassCommited = false
    this.gold_result = null                 // 金币结果，传给端

    this.checkData = null                   // 检查结果

    this.modal = undefined
    bindAll(this, [
      "submit",
      "save",
      "share",
      "check",
      "init",
      'setAutoSubmitMark',
      'setAnswerStartTime',
      'submitToServer',
      'bindIframeCloseModalFunc',
      'getSubmitFunction'
    ])

  }
  /**
   * 提交结果给端
   * @param {*} isAuto  是否自动提交
   * @param {*} getGoldNum 学生获取的金币
   * @param {*} inputGoldNum 总金币数
   * @param {*} testId testID
   */
  submitAnswerResult(isAuto, getGoldNum, inputGoldNum, testId, gold_result) {
    let isRight = 0
    // // 答对10，答错5
    let energyNum = 5
    let inputNum = inputGoldNum
    let goldNum = getGoldNum

    if (!inputNum) inputNum = 0
    if (!goldNum) goldNum = 0

    inputNum = parseInt(inputNum)
    goldNum = Math.ceil(goldNum)

    let submitType = isAuto ? 'force' : 'normal'

    if (inputNum === goldNum) {
        isRight = 1
        energyNum = 10
    } else if (goldNum > 0) {
        isRight = 2
    }
    if (this.bigClassCommited){
      goldNum = 0
      energyNum = 0
    }
    console.log('setAnswerResult',inputNum, energyNum, testId, isRight, submitType)
    xesBridge.setAnswerResult(
      {
        goldNum,
        energyNum, 
        testId, 
        isRight, 
        submitType
      },
      gold_result  
    )
  }
  setModal (modal) {
    this.modal = modal
  }
  setAnswerStartTime(start) {
    this.answerStartTime = start
  }
  setAutoSubmitMark(isAutoSubmit) {
    this.isAuto = isAutoSubmit
  }
  init(state, dispatch) {
    this.dispatch = dispatch
    this.setAnswerStartTime(Date.now())
    document.getElementsByTagName('iframe')[0].style.display = 'none';
    Object.assign(window.Xes, {
      /**
       * 自动提交
       */
      AutoSubmit: () => {
        this.setAutoSubmitMark(true)
        dispatch(onXESConfirmSubmit())
      }
    })
    xesBridge.addListenerFunction('forceResult', () => {
      this.setAutoSubmitMark(true)
      this.dispatch(onXESConfirmSubmit())
    })
  }
  getProjectData() { /* can be override */
    let pid = getQuery('pid')
    if (pid) return http.getProjectById(pid)
    return http.getLiveProject(this.liveParams)
  }
  getSubmitFunction(projectParams, varParams){ /* can be override */
    return http.submitLiveProject({...projectParams, ...this.liveParams, ...varParams})
  }
  submit(projectMeta) {
      // 防止未加载时提交空数据
      if(projectMeta.xml){
        let vmJson = JSON.parse(projectMeta.xml).vmJson
        if(vmJson && !vmJson.targets.length){
          return Promise.resolve(null)
        }
      }
      if (this.isAuto) {
        projectMeta = {
          ...projectMeta,
          isForce: 1
        }
      } else {
        projectMeta = {
          ...projectMeta,
          isForce: 0
        }
      }

      let projectParams = sliceObject([
        "id",
        "version",
        "thumbnail",
        "xml",
        "name",
        "original_id",
        "isForce"
      ], projectMeta)
      
      let durationInSecond = (Date.now() - this.answerStartTime) / 1000
      //let goldNum = getQuery('goldNum')
      
      if (this.needNotCorrect) {
        return this.submitToServer(projectParams, {
          duration: durationInSecond
        })
      }
      let fakeDataCheck = {
        data: {
            data: {
              data: {
                msg: "提交即为正确(不修改也可以)",
                success_index: "no_check",
                work_type: "6",
              },
              result: "success"
            },
            msg: "错误：",
            stat: 1,
            status: 1,

        }
      }
      const handleSubmitParams = () => {
        let checkResult
        return new Promise((resolve, reject) => {
          let _data = this.checkData.data.data.data,
            isBlank = 0,
            duration = (Date.now() - this.startTime)/1000
          checkResult = this.checkData.data.data.result
          let fail_index = (_data.fail_index && (_data.fail_index === 'no_changes' ? 'no_changes' : 'fail'))
              || 'success'
          if (fail_index === 'no_changes') {  // 如果空白显示
              isBlank = 1
          }
          if (this.checkData === null) {
            return resolve(null)
          }
          if (checkResult === 'fail') {
            this.goldNum = this.goldNum / 2
          }
          let checkParams = this.checkParams = this.checkData.data

          return this.submitToServer(projectParams, {
            gold: this.goldNum,
            duration: durationInSecond,
            answer_result: checkParams
          }, this.goldNum, checkResult).then(res => {
            resolve(res)
          })
        }).catch((err) => {
          console.log("提交错误：",err)
          this.checkData = fakeDataCheck
          this.checkData.data.msg = this.checkData.data.msg + err

          return this.submitToServer(projectParams, {
            gold: this.goldNum,
            duration: durationInSecond,
            answer_result: fakeDataCheck.data
          }, this.goldNum, checkResult)
        }).then(dataSubmit => ({...this.checkData, ...dataSubmit}))
      }

      if(this.isAuto) {
        return this.check(projectMeta).then(() => {
          return handleSubmitParams()
        })
      } else {
        return handleSubmitParams()
      }
  }
  submitToServer(projectParams, varParams) {
      return this.getSubmitFunction(projectParams,varParams)
  }
  onDoneSubmit(state, dispatch, data) { /* can be override */
    // 已经提交过的处理
    if(data && data.gold_result && data.gold_result.code === 60902) {
        this.bigClassCommited = true
    }
    let gold_result = this.gold_result = data.gold_result
    if (this.isAuto) {
      this.setAutoSubmitMark(false)
      //战队PK
      this.submitAnswerResult(
        this.isAuto, // 是否为自动提交
        this.goldNum, // 学生获得的金币数
        this.inputGoldNum, // 金币总数
        this.testId, // testId
        gold_result
      )
      setTimeout(()=>{
        xesBridge.closeWindowFunction()
      }, 5000)
      // return
    }
    
    let goldUrl = this.needNotCorrect ? '' : getGoldUrl(data)
    let isPreview = !window.location.href.includes('stuId')
    let isPlayback = getQuery('isPlayback') === '1'
    // 重复提交且不是回放且不是白泽题目，或者预览模式, 或者是旧端，才展示金币弹窗
    if(
      (this.bigClassCommited && !isPlayback) ||
      isPreview||
      !xesBridge.isNewClientFunction()
    ){
      this.modal.toggle(true, goldUrl)
    }

    let closeTimer = null
    if (getCanBeShare()) {
      genQrCode(genShareUrl(data.id), 'xes-classwork-share')
    } else if (this.needNotCorrect) {
      //战队PK
      this.submitAnswerResult(
        this.isAuto, // 是否为自动提交
        this.goldNum, // 学生获得的金币数
        this.inputGoldNum, // 金币总数
        this.testId, // testId
        gold_result
      )
      xesBridge.closeWindowFunction()
      this.modal.toggle(false)
    } else {
      closeTimer = window.setTimeout(() => {
        //战队PK
        this.submitAnswerResult(
            this.isAuto, // 是否为自动提交
            this.goldNum, // 学生获得的金币数
            this.inputGoldNum, // 金币总数
            this.testId, // testId
            gold_result
        )
        xesBridge.closeWindowFunction()
        // iframe加载完成后，关闭弹窗
        // 如果一直没有加载好，再过3s关闭
        // this.modal.toggle(false)
        window.setTimeout(() => {
          this.modal.toggle(false)
        }, 3000);
      }, 5000)
    }
    this.bindIframeCloseModalFunc(closeTimer, dispatch)
    this.postMessage && this.postMessage(data)
  }
  bindIframeCloseModalFunc(closeTimer, dispatch) {
    window.ToggleModal = {}
    window.ToggleModal.closeModal = () => {
      if (closeTimer) {
        window.clearTimeout(closeTimer)
      }
      //战队PK
      this.submitAnswerResult(
        this.isAuto, // 是否为自动提交
        this.goldNum, // 学生获得的金币数
        this.inputGoldNum, // 金币总数
        this.testId, // testId
        this.gold_result
      )
      xesBridge.closeWindowFunction()
      this.modal.toggle(false)
    }
  }
  save(projectMeta) { 
    return this.handleLockMethod(() => {
        let projectParams = sliceObject([
          "id",
          "version",
          "thumbnail",
          "xml",
          "original_id",
          "name"
        ], projectMeta)
        
        return http.saveLiveProject({...projectParams, ...this.liveParams})
    })
  }
  share(projectMeta) {
    return this.save(projectMeta)
  }
  check(projectMeta){ /* can be override */
    return this.handleLockMethod(() => {
      let projectParams = sliceObject([
        "xml",
      ], projectMeta)
      projectParams['xml'] = extractVmJson(projectParams['xml'])
      return new Promise((resolve, reject) => {
        http.checkCode({...projectParams, ...this.liveParams}).then(res => {
          this.checkData = res
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    })
  }
  static getInstance() {
    if (ClassHandler.instance === null) {
      ClassHandler.instance = new ClassHandler()
    }
    return ClassHandler.instance
  }
}
ClassHandler.instance = null

export default ClassHandler